import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_payment_method_btn = _resolveComponent("add-payment-method-btn")!
  const _component_payment_method_list = _resolveComponent("payment-method-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_add_payment_method_btn, {
      "customer-id": _ctx.customerId,
      color: "primary",
      rounded: "",
      onAdded: _ctx.push
    }, null, 8, ["customer-id", "onAdded"]),
    _createVNode(_component_payment_method_list, {
      "customer-id": _ctx.customerId,
      class: "q-mt-lg",
      ref: "list"
    }, null, 8, ["customer-id"])
  ]))
}